/**
 * svgtoreact
 *
 * @author Michael Hsu
 */

import React from 'react';

export default function SVGData(props) {
  return (
    <svg width={42} height={32} viewBox="0 0 42 32" {...props}>
      <g fill="none">
        <path d="M-9-14h60v60h-60z" />
        <path
          d="M36.984 10.723l-7.261 7.261c.176.298.277.645.277 1.016 0 1.105-.895 2-2 2s-2-.895-2-2c0-.144.015-.284.044-.419l-6.535-3.268c-.367.421-.907.687-1.508.687-.371 0-.718-.101-1.016-.277l-7.261 7.261c.176.298.277.645.277 1.016 0 1.105-.895 2-2 2s-2-.895-2-2 .895-2 2-2c.371 0 .718.101 1.016.277l7.261-7.261c-.176-.298-.277-.645-.277-1.016 0-1.105.895-2 2-2s2 .895 2 2c0 .144-.015.284-.044.419l6.535 3.268c.367-.421.907-.687 1.508-.687.371 0 .718.101 1.016.277l7.261-7.261c-.176-.298-.277-.645-.277-1.016 0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2c-.371 0-.718-.101-1.016-.277zm-34.984-9.723v29h39c.552 0 1 .448 1 1s-.448 1-1 1h-41v-31c0-.552.448-1 1-1s1 .448 1 1z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/SVG/SVGData.js